import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Accordion } from './Accordion';
import { CTAButton } from './CTAButton';
import { bonuses } from '../data/content';
export function Bonuses() {
  const data = bonuses.map(b => ({
    ...b,
    badge: 'Gratis hoy'
  }));
  return <section className="px-5 py-8" aria-labelledby="bonos-title" data-id="element-40" data-mp="fu6cuj38jlbr">
      <div className="flex items-center justify-center gap-2" data-id="element-41" data-mp="fslesjhppk95">
        <GiftIcon className="h-5 w-5 text-[#b4553f]" aria-hidden="true" data-id="element-42" data-mp="1u5b71f5c9v8" />
        <h2 id="bonos-title" className="font-display text-[24px] text-[#16302a]" data-id="element-43" data-mp="5w08zvxvc549">
          Además, hoy te llevas:
        </h2>
      </div>
      <p className="mt-2 text-center text-[13px] font-semibold text-[#b4553f]" data-id="element-44" data-mp="3o2mz1kkfrgcs">
        Estos 5 bonos son gratis solo por el día de hoy.
      </p>

      <div className="mt-5" data-id="element-45" data-mp="3t2j4zpcp1huz">
        <Accordion data={data} defaultOpen={0} data-id="element-46" data-mp="1m9qen74mz1g0" />
      </div>

      <div className="mt-6" data-id="element-47" data-mp="1m8fedhaegbtn">
        <CTAButton label="Quiero los bonos gratis" data-id="element-48" data-mp="1r9uztaghokck" />
      </div>
    </section>;
}